import React from 'react'
import './Breadcrumbs.components.scss'

const ChevronSeparator = () => (
  <span className='breadcrumbs-nav__separator' aria-hidden='true'>
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.46967 3.46967C5.76256 3.17678 6.23744 3.17678 6.53033 3.46967L10.5303 7.46967C10.8232 7.76256 10.8232 8.23744 10.5303 8.53033L6.53033 12.5303C6.23744 12.8232 5.76256 12.8232 5.46967 12.5303C5.17678 12.2374 5.17678 11.7626 5.46967 11.4697L8.93934 8L5.46967 4.53033C5.17678 4.23744 5.17678 3.76256 5.46967 3.46967Z'
        fill='currentColor'
      />
    </svg>
  </span>
)

const Breadcrumbs = ({ items }) => {
  return (
    <div className='breadcrumbs-wrapper'>
      <nav className='breadcrumbs-nav' aria-label='Breadcrumbs'>
        {items.map((item, index) => {
          const isLast = index === items.length - 1

          return (
            <React.Fragment key={item.label}>
              {index > 0 && <ChevronSeparator />}
              {item.href && !isLast ? (
                <a href={item.href} className='breadcrumbs-nav__link'>
                  {item.label}
                </a>
              ) : (
                <span className={isLast ? 'breadcrumbs-nav__current' : 'breadcrumbs-nav__text'}>{item.label}</span>
              )}
            </React.Fragment>
          )
        })}
      </nav>
    </div>
  )
}

export default Breadcrumbs
